import { BRAND } from "@/constants/site";

const Navbar = () => (
  <nav
    data-testid="main-nav"
    className="sticky top-0 z-50 border-b border-fuchsia-500/20 bg-[#110e1a]/90 backdrop-blur-md px-6 py-4"
  >
    <div className="max-w-6xl mx-auto flex items-center justify-between">
      <a href="/" className="flex items-center gap-3" data-testid="nav-brand">
        <svg className="w-8 h-8 text-[#ec4899]" viewBox="0 0 32 32" fill="none">
          <polygon points="16,2 30,16 16,30 2,16" stroke="currentColor" strokeWidth="2" />
          <polygon points="16,8 24,16 16,24 8,16" fill="currentColor" className="opacity-40" />
        </svg>
        <span className="font-poster text-2xl tracking-wide uppercase text-white">{BRAND}</span>
      </a>
      <div className="flex items-center gap-4">
        <a
          href="/#services"
          data-testid="nav-services-link"
          className="hidden sm:inline text-xs uppercase font-mono tracking-widest text-slate-400 hover:text-white transition-colors"
        >
          Services
        </a>
        <a
          href="/reviews"
          data-testid="nav-reviews-link"
          className="hidden sm:inline text-xs uppercase font-mono tracking-widest text-slate-400 hover:text-white transition-colors"
        >
          Reviews
        </a>
        <a
          href="/#faq"
          data-testid="nav-faq-link"
          className="hidden sm:inline text-xs uppercase font-mono tracking-widest text-slate-400 hover:text-white transition-colors"
        >
          FAQ
        </a>
        <a
          href="/#contact"
          data-testid="nav-order-btn"
          className="px-5 py-2 rounded-lg bg-gradient-to-r from-pink-500 to-violet-600 hover:opacity-90 text-white text-xs font-bold uppercase tracking-wider transition-opacity shadow-lg shadow-pink-500/20"
        >
          Order 24/7
        </a>
      </div>
    </div>
  </nav>
);

export default Navbar;
